import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <header className="relative pt-[170px] pb-[90px] overflow-hidden" id="top" data-id="element-77">
      {/* Glows */}
      <div className="absolute top-[-15%] right-[-10%] w-[780px] h-[780px] rounded-full bg-[radial-gradient(circle,rgba(196,255,61,0.16),transparent_62%)] blur-[20px] pointer-events-none z-0" data-id="element-78"></div>
      <div className="absolute top-[35%] left-[-22%] w-[620px] h-[620px] rounded-full bg-[radial-gradient(circle,rgba(54,232,192,0.13),transparent_64%)] blur-[20px] pointer-events-none z-0" data-id="element-79"></div>

      <div className="max-w-wrap mx-auto px-7 relative z-10" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1]
      }} className="inline-flex items-center gap-[10px] border border-line-strong rounded-full py-[7px] px-4 text-[0.74rem] tracking-[0.04em] text-ink-dim mb-[34px]" data-id="element-81">
          <span className="w-[7px] h-[7px] rounded-full bg-cyan shadow-[0_0_10px_var(--cyan)]" data-id="element-82"></span>
          Agencia de performance · Facebook &amp; Instagram Ads
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.07
      }} className="text-[clamp(2.9rem,8.2vw,7.2rem)] leading-[0.94] font-bold tracking-[-0.035em] max-w-[15ch]" data-id="element-83">
          No vendemos{' '}
          <span className="font-serif font-normal italic tracking-normal" data-id="element-84">
            clics.
          </span>
          <br data-id="element-85" />
          Conseguimos <span className="text-acid" data-id="element-86">leads</span> que
          <br data-id="element-87" />
          se convierten en <span className="text-acid" data-id="element-88">ventas.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.14
      }} className="mt-[30px] max-w-[48ch] text-[1.18rem] text-ink-dim leading-[1.5]" data-id="element-89">
          Somos LEADS AND WIN: una agencia obsesionada con el rendimiento
          medible. Construimos sistemas de captación en Meta Ads que llenan tu
          agenda y tu caja — no tu carpeta de capturas bonitas.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.21
      }} className="mt-[42px] flex gap-4 flex-wrap items-center" data-id="element-90">
          <a href="#contacto" className="bg-acid text-[#0a0c0b] py-4 px-[30px] rounded-full font-bold text-[1rem] transition-all duration-250 inline-flex items-center gap-[10px] hover:-translate-y-[3px] hover:shadow-[0_14px_40px_rgba(196,255,61,0.32)] group" data-id="element-91">
            Solicita tu auditoría gratuita{' '}
            <span className="transition-transform duration-250 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-92">
              ↗
            </span>
          </a>
          <a href="#resultados" className="py-4 px-[26px] rounded-full border border-line-strong font-semibold text-[1rem] text-ink transition-all duration-250 hover:border-ink hover:bg-[rgba(243,245,239,0.04)]" data-id="element-93">
            Ver resultados reales
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.28
      }} className="mt-[88px] border-y border-line grid grid-cols-2 md:grid-cols-4" data-id="element-94">
          <div className="py-[30px] px-6 md:border-l-0 border-l-0 md:pl-0 pl-0 border-b md:border-b-0 border-line" data-id="element-95">
            <div className="text-[clamp(2rem,4vw,3rem)] font-bold tracking-[-0.03em] leading-none" data-id="element-96">
              +€14<span className="text-acid" data-id="element-97">M</span>
            </div>
            <div className="mt-[10px] text-[0.82rem] text-ink-faint leading-[1.4]" data-id="element-98">
              Invertidos y gestionados en Meta Ads
            </div>
          </div>
          <div className="py-[30px] px-6 border-l border-line border-b md:border-b-0" data-id="element-99">
            <div className="text-[clamp(2rem,4vw,3rem)] font-bold tracking-[-0.03em] leading-none" data-id="element-100">
              3,8<span className="text-acid" data-id="element-101">x</span>
            </div>
            <div className="mt-[10px] text-[0.82rem] text-ink-faint leading-[1.4]" data-id="element-102">
              ROAS medio en cuentas escaladas
            </div>
          </div>
          <div className="py-[30px] px-6 md:border-l border-l-0 border-line md:pl-6 pl-0" data-id="element-103">
            <div className="text-[clamp(2rem,4vw,3rem)] font-bold tracking-[-0.03em] leading-none" data-id="element-104">
              120<span className="text-acid" data-id="element-105">+</span>
            </div>
            <div className="mt-[10px] text-[0.82rem] text-ink-faint leading-[1.4]" data-id="element-106">
              Campañas lanzadas y optimizadas
            </div>
          </div>
          <div className="py-[30px] px-6 border-l border-line" data-id="element-107">
            <div className="text-[clamp(2rem,4vw,3rem)] font-bold tracking-[-0.03em] leading-none" data-id="element-108">
              -41<span className="text-acid" data-id="element-109">%</span>
            </div>
            <div className="mt-[10px] text-[0.82rem] text-ink-faint leading-[1.4]" data-id="element-110">
              Coste por lead medio tras 60 días
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}